export default __webpack_public_path__ + "static/media/avatar_arrow_boy6.ab4eeede.mp3";